// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Avatar Selection Modal */
.avatar-selection-modal {
  position: fixed;
  background: rgb(242, 242, 242);
  border-radius: 4px;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);
  padding: 16px;
  z-index: 10000;
  width: 202px;
  height: 302px;
}

/* Triangular speech bubble pointer pointing left */
.avatar-selection-modal::before {
  content: '';
  position: absolute;
  top: 3px;
  left: -8px;
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-right: 8px solid rgb(242, 242, 242);
  filter: drop-shadow(-2px 0 2px rgba(0, 0, 0, 0.1));
}

.avatar-selection-modal-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 100%;
  width: 100%;
  overflow-y: auto;
}

/* Custom scrollbar styling */
.avatar-selection-modal-wrapper::-webkit-scrollbar {
  width: 16px;
}

.avatar-selection-modal-wrapper::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 8px;
}

.avatar-selection-modal-wrapper::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.15);
  border-radius: 8px;
}

.avatar-selection-modal-wrapper::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

/* Modal buttons (Slat-style) */
.avatar-modal-option {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 12px 4px;
  border: none;
  background: transparent;
  cursor: pointer;
  transition: background-color 0.2s;
  font-family: Roboto, Arial, sans-serif;
  font-size: 14px;
  line-height: 14px;
  text-align: left;
  color: rgb(74, 74, 74);
}

.avatar-modal-option:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.avatar-modal-option:active {
  background-color: rgba(0, 0, 0, 0.15);
}

.avatar-modal-option.selected {
  background-color: rgba(0, 0, 0, 0.15);
}

/* Avatar preview in modal buttons */
.avatar-modal-preview {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.avatar-modal-preview-placeholder {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #000;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;
  flex-shrink: 0;
}

.avatar-modal-icon-wrapper {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(74, 74, 74);
  border-radius: 50%;
  flex-shrink: 0;
}

.avatar-modal-icon-wrapper ion-icon {
  font-size: 24px;
  color: rgb(242, 242, 242);
}

.avatar-modal-option-text {
  flex: 1;
  color: rgb(74, 74, 74);
  font-size: 14px;
  line-height: 14px;
  padding-left: 16px;
}

/* Preset avatars grid */
.avatar-modal-presets {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px 8px;
  padding: 4px;
}

.avatar-modal-preset-option {
  width: 48px;
  height: 48px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.avatar-modal-preset-option:hover::before {
  content: '';
  position: absolute;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 0;
}

.avatar-modal-preset-option:active::before {
  content: '';
  position: absolute;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 0;
}

.avatar-modal-preset-option.selected::before {
  content: '';
  position: absolute;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 0;
}

.avatar-modal-preset-image {
  width: 40px;
  height: 40px;
  object-fit: contain;
  position: relative;
  z-index: 1;
}
`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/AvatarSelectionModal.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;EAClB,0EAA0E;EAC1E,aAAa;EACb,cAAc;EACd,YAAY;EACZ,aAAa;AACf;;AAEA,mDAAmD;AACnD;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,oCAAoC;EACpC,0CAA0C;EAC1C,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,iCAAiC;EACjC,sCAAsC;EACtC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,OAAO;EACP,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,qCAAqC;EACrC,aAAa;EACb,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ","sourcesContent":["/* Avatar Selection Modal */\n.avatar-selection-modal {\n  position: fixed;\n  background: rgb(242, 242, 242);\n  border-radius: 4px;\n  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);\n  padding: 16px;\n  z-index: 10000;\n  width: 202px;\n  height: 302px;\n}\n\n/* Triangular speech bubble pointer pointing left */\n.avatar-selection-modal::before {\n  content: '';\n  position: absolute;\n  top: 3px;\n  left: -8px;\n  width: 0;\n  height: 0;\n  border-top: 8px solid transparent;\n  border-bottom: 8px solid transparent;\n  border-right: 8px solid rgb(242, 242, 242);\n  filter: drop-shadow(-2px 0 2px rgba(0, 0, 0, 0.1));\n}\n\n.avatar-selection-modal-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  height: 100%;\n  width: 100%;\n  overflow-y: auto;\n}\n\n/* Custom scrollbar styling */\n.avatar-selection-modal-wrapper::-webkit-scrollbar {\n  width: 16px;\n}\n\n.avatar-selection-modal-wrapper::-webkit-scrollbar-track {\n  background: rgba(0, 0, 0, 0.05);\n  border-radius: 8px;\n}\n\n.avatar-selection-modal-wrapper::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.15);\n  border-radius: 8px;\n}\n\n.avatar-selection-modal-wrapper::-webkit-scrollbar-thumb:hover {\n  background: rgba(0, 0, 0, 0.3);\n}\n\n/* Modal buttons (Slat-style) */\n.avatar-modal-option {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 12px 4px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  font-family: Roboto, Arial, sans-serif;\n  font-size: 14px;\n  line-height: 14px;\n  text-align: left;\n  color: rgb(74, 74, 74);\n}\n\n.avatar-modal-option:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.avatar-modal-option:active {\n  background-color: rgba(0, 0, 0, 0.15);\n}\n\n.avatar-modal-option.selected {\n  background-color: rgba(0, 0, 0, 0.15);\n}\n\n/* Avatar preview in modal buttons */\n.avatar-modal-preview {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  object-fit: cover;\n  flex-shrink: 0;\n}\n\n.avatar-modal-preview-placeholder {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-color: #000;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: bold;\n  text-transform: uppercase;\n  flex-shrink: 0;\n}\n\n.avatar-modal-icon-wrapper {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgb(74, 74, 74);\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.avatar-modal-icon-wrapper ion-icon {\n  font-size: 24px;\n  color: rgb(242, 242, 242);\n}\n\n.avatar-modal-option-text {\n  flex: 1;\n  color: rgb(74, 74, 74);\n  font-size: 14px;\n  line-height: 14px;\n  padding-left: 16px;\n}\n\n/* Preset avatars grid */\n.avatar-modal-presets {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px 8px;\n  padding: 4px;\n}\n\n.avatar-modal-preset-option {\n  width: 48px;\n  height: 48px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.avatar-modal-preset-option:hover::before {\n  content: '';\n  position: absolute;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background-color: rgba(0, 0, 0, 0.2);\n  z-index: 0;\n}\n\n.avatar-modal-preset-option:active::before {\n  content: '';\n  position: absolute;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background-color: rgba(0, 0, 0, 0.2);\n  z-index: 0;\n}\n\n.avatar-modal-preset-option.selected::before {\n  content: '';\n  position: absolute;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background-color: rgba(0, 0, 0, 0.2);\n  z-index: 0;\n}\n\n.avatar-modal-preset-image {\n  width: 40px;\n  height: 40px;\n  object-fit: contain;\n  position: relative;\n  z-index: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
